import React from "react";
import styles from "./AppHeader.module.scss";
import Icon from "../../../../../../../../../../../components/Icon";
import FoldingText from "../../../../../../../../../../../components/folding/FoldingText";
import DraftHTML from "../../../../../../../../../../../components/draftEditor/export/DraftHTML";

export function AppHeader({app}) {
    return (
        <div className={styles.head}>
            <div className={styles.head__logo}>
                <Icon
                    className={styles.head__logo__image}
                    icon={app.icon}
                    fallbackImages={['/images/no-app-icon.svg', '/images/no-app-icon-dark.svg']}
                    alt={app.name || app.code}
                />
            </div>
            <div className={styles.head__info}>
                <div className={styles.head__info__title}>{app.name || app.code || 'Untitled app'}</div>
                {
                    (
                        app.description // usual app
                        || app.short_description // user's custom app
                    )
                        ?
                        <FoldingText>
                            <DraftHTML
                                className={styles.head__info__description}
                                content={app.description || app.short_description}
                            />
                        </FoldingText>
                        : <div className={styles['head__info__no-description']}>No description</div>
                }
            </div>
        </div>
    )
}